import React, { useState } from "react";
import "../styles/HeadToHeadCreate.css";

function calculateH2HMaintenanceFee(amount) {
  if (amount <= 200) return 10;
  if (amount <= 500) return 15;
  if (amount <= 700) return 20;
  if (amount <= 1500) return 25;
  if (amount <= 5000) return 30;
  return 50;
}

function HeadToHeadJoin({ onClose }) {
  const userId = localStorage.getItem("userId");
  const [matchCode, setMatchCode] = useState("");
  const [phone, setPhone] = useState("");
  const [matchDetails, setMatchDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleFindMatch = async () => {
    if (!matchCode) {
      alert("Enter a match code");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/h2h/match/${matchCode}`);
      const data = await res.json();

      if (data.success) {
        setMatchDetails(data);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = async () => {
    if (!phone) {
      alert("Enter your phone number");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/h2h/join`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ matchCode, phone, userId }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const maintenanceFee = matchDetails ? calculateH2HMaintenanceFee(matchDetails.amount) : 0;
  const totalCharge = matchDetails ? matchDetails.amount + maintenanceFee : 0;

  return (
    <div className="h2h-create-overlay">
      <div className="h2h-create-modal">
        <button className="close-btn" onClick={onClose}>×</button>

        {success ? (
          <div className="match-code-box">
            <h3>Payment Initiated</h3>
            <p>Check your phone to complete the payment.</p>
            <button onClick={onClose}>Done</button>
          </div>

        ) : matchDetails ? (
          <>
            <h3>Match Found</h3>
            <p className="h2h-match-info">
              KES {matchDetails.amount} · Gameweek {matchDetails.gameweek}
            </p>
            <p className="h2h-maintenance-fee-note">
              You will be charged KES {totalCharge} (KES {matchDetails.amount} stake + KES {maintenanceFee} maintenance fee)
            </p>
            <input
              type="tel"
              placeholder="Enter your phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <button onClick={handleJoin} disabled={loading} className="create-button-create">
              {loading ? "Processing..." : "Join & Pay"}
            </button>
          </>

        ) : (
          <>
            <h3>Join a Match</h3>
            <input
              type="text"
              placeholder="Enter match code"
              value={matchCode}
              onChange={(e) => setMatchCode(e.target.value.toUpperCase())}
            />
            <button onClick={handleFindMatch} disabled={loading} className="create-button-create">
              {loading ? "Looking up..." : "Find Match"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default HeadToHeadJoin;